import React from "react";

function VeryBadIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 37.732 37.732">
      <path
        d="M18.866,0A18.866,18.866,0,1,1,0,18.866,18.866,18.866,0,0,1,18.866,0Z"
        fill="#d8363f"
      />
      <path
        d="M17.814,4.93A13.054,13.054,0,1,0,30.867,17.984,13.054,13.054,0,0,0,17.814,4.93Zm0,24.239A11.185,11.185,0,1,1,29,17.984,11.185,11.185,0,0,1,17.814,29.169Z"
        transform="translate(1.052 1.09)"
        fill="#fff"
      />
      <ellipse
        cx="1.868"
        cy="1.868"
        rx="1.868"
        ry="1.868"
        transform="translate(12.345 15.337)"
        fill="#fff"
      />
      <ellipse
        cx="1.868"
        cy="1.868"
        rx="1.868"
        ry="1.868"
        transform="translate(21.662 15.337)"
        fill="#fff"
      />
      <path
        d="M19.7,20.331a.928.928,0,0,1-1.307.183h0a3.737,3.737,0,0,0-4.42,0,.928.928,0,0,1-1.319-.1.94.94,0,0,1,.1-1.319h0a5.568,5.568,0,0,1,6.765,0,.94.94,0,0,1,.183,1.233Z"
        transform="translate(2.747 3.969)"
        fill="#fff"
      />
    </svg>
  );
}

export { VeryBadIcon };
